export const DEFAULT_SORT_DIRECTION: 'DESC'|'ASC' = 'DESC';
export const SECONDARY_SORT_DIRECTION: 'DESC'|'ASC' = 'ASC';
